import { createFileRoute } from "@tanstack/react-router";
import { JourneyWorkspace } from "@/components/JourneyWorkspace";
import { pageTitle } from "@/lib/brand";

export const Route = createFileRoute("/app/$customerId/journey")({
  head: () => ({ meta: [{ title: pageTitle("Journey") }] }),
  component: Journey,
});
function Journey() {
  const { customerId } = Route.useParams();
  return <JourneyWorkspace customerId={customerId} />;
}
